export default __webpack_public_path__ + "static/media/line04.e82db7ab.jpg";